'use client';

import React, { useMemo } from 'react';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import { useRecommendedQuests } from '@zealy/queries';

import type { QuestData } from '#components/QuestCard';
import { Carousel, QuestCard } from '#components';

const HOME_PAGE_CAROUSEL_LIMIT_SIZE = 10;

export const RecommendedQuestsCarousel = () => {
  const t = useTranslations('explore');

  const { fetchNextPage, data } = useRecommendedQuests(HOME_PAGE_CAROUSEL_LIMIT_SIZE);

  const quests = useMemo(() => (data?.pages ?? []).flatMap(page => page.results), [data?.pages]);

  // if (!quests?.length) return null;

  const totalQuests = data?.pages?.[0]?.totalQuests ?? 0;

  return (
    <Carousel
      showAllLabel={t('show-all')}
      showAllLink={`/earn`}
      title={'Guaranteed rewards'}
      totalItems={totalQuests}
      onFetchMore={fetchNextPage}
      key="recommended-quests"
      className="py-400"
      shouldShowAll={true}
    >
      {quests?.map(
        (quest: any) =>
          quest && (
            <QuestCard
              key={quest.id}
              quest={
                {
                  ...quest,
                  canRetry: true,
                  conditions: [],
                } as unknown as QuestData
              }
              displayCommunityData={{
                name: quest.communityName,
                imageUrl: quest.communityImageUrl,
              }}
              href={`/cw/${quest.subdomain}/questboard/${quest.categoryId}/${quest.id}`}
              className={cx(
                'w-[458px] max-w-[85vw]',
                'h-full transition-transform hover:scale-[1.01] duration-200 ease-out',
                'border border-component-tertiary hover:border-component-tertiary-hover',
              )}
            />
          ),
      )}
    </Carousel>
  );
};
